import { render, staticRenderFns } from "./ModalAnnotazioni.vue?vue&type=template&id=2fc59f76"
import script from "./ModalAnnotazioni.vue?vue&type=script&lang=js"
export * from "./ModalAnnotazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports